import { Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { union_type, unit_type, record_type, class_type, bool_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Shopfoo_Shared_Remoting_FullContext__FullContext_PrepareRequest_1505, Remote_ofResult, Remote$1, ApiRequestArgs$2, ApiCall$1, Cmder__ofApiRequest_Z503C4AF9, ApiCall$1_$reflection, Remote$1_$reflection } from "../Remoting.js";
import { Result_Map, FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { Cmd_none } from "../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { FullContext__get_Now } from "../Shopfoo.Shared/Remoting.js";
import { createElement } from "react";
import React from "react";
import { Shopfoo_Client_Pages_Shared_Env_IFullContext__IFullContext_get_Translations } from "./Shared.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { TranslationPages_Home__ResetProductCacheSuccess_7F9DDECF, TranslationPages_Home__get_ResetProductCache, TranslationPages_Home__get_ResetProductCacheDisclaimer, TranslationPages_Home__get_ProductCache, TranslationPages_Home__get_AdminDisclaimer, TranslationPages_Home__get_Admin, TranslationPages_Home__get_ConfirmResetCacheMessage, TranslationPages_Home__get_Cancel, TranslationPages_Home__get_Confirmation, AppTranslations__get_Home, TranslationPages_Home__get_ConfirmReset, AppTranslations__get_IsEmpty } from "../Shopfoo.Shared/Translations.js";
import { Page, Router_navigatePage } from "../Routing.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.Elmish.4.2.0/program.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { empty, singleton, append, delay, toList, iterate } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { toArray } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { JS_runAfter } from "../UI.js";
import { equals, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.DaisyUI.5.0.0/DaisyUI.fs.js";
import { ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { ModalDialog, DialogProps, DialogTranslations } from "../Components/Dialog.js";
import { apiError as apiError_1 } from "../Components/Alert.js";

class Model extends Record {
    constructor(ShowModal, ResetStatus) {
        super();
        this.ShowModal = ShowModal;
        this.ResetStatus = ResetStatus;
    }
}

function Model_$reflection() {
    return record_type("Shopfoo.Client.Pages.Admin.Model", [], Model, () => [["ShowModal", bool_type], ["ResetStatus", Remote$1_$reflection(class_type("System.DateTime"))]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["OpenModal", "CloseModal", "ResetCache", "ClearResetStatus"];
    }
}

function Msg_$reflection() {
    return union_type("Shopfoo.Client.Pages.Admin.Msg", [], Msg, () => [[], [], [["Item", ApiCall$1_$reflection(unit_type)]], []]);
}

function Cmd_resetCache(cmder, request) {
    return Cmder__ofApiRequest_Z503C4AF9(cmder, new ApiRequestArgs$2((api) => api.Admin.ResetProductCache(request), (arg_1) => (new Msg(2, [new ApiCall$1(1, [new FSharpResult$2(1, [arg_1])])])), () => (new Msg(2, [new ApiCall$1(1, [new FSharpResult$2(0, [undefined])])]))));
}

function init() {
    return [new Model(false, new Remote$1(0, [])), Cmd_none()];
}

function update(fullContext, msg, model) {
    let tupledArg;
    switch (msg.tag) {
        case 1:
            return [new Model(false, model.ResetStatus), Cmd_none()];
        case 2:
            if (msg.fields[0].tag === 1) {
                return [new Model(model.ShowModal, Remote_ofResult(Result_Map(() => FullContext__get_Now(fullContext), msg.fields[0].fields[0]))), Cmd_none()];
            }
            else {
                return [new Model(model.ShowModal, new Remote$1(1, [])), (tupledArg = Shopfoo_Shared_Remoting_FullContext__FullContext_PrepareRequest_1505(fullContext, undefined), Cmd_resetCache(tupledArg[0], tupledArg[1]))];
            }
        case 3:
            return [new Model(model.ShowModal, new Remote$1(0, [])), Cmd_none()];
        default:
            return [new Model(true, model.ResetStatus), Cmd_none()];
    }
}

export function AdminView(adminViewInputProps) {
    let Title, Close, elems_4, elems, elems_3;
    const env = adminViewInputProps.env;
    let fullContext;
    let copyOfStruct = env;
    fullContext = copyOfStruct.FullContext;
    const translations = Shopfoo_Client_Pages_Shared_Env_IFullContext__IFullContext_get_Translations(env);
    useEffectOnce(() => {
        if (AppTranslations__get_IsEmpty(translations)) {
            Router_navigatePage(new Page(3, []));
        }
    });
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init, (msg, model) => update(fullContext, msg, model), (_arg, _arg_1) => {
    }), undefined, []);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    const modalRef = reactApi.useRef(undefined);
    const updateModal = (f) => {
        iterate((_arg_2) => {
            if (_arg_2 instanceof HTMLDialogElement) {
                const dialog = _arg_2;
                f(dialog);
            }
        }, toArray(modalRef.current));
    };
    reactApi.useEffect(() => {
        let matchResult;
        if (model_1.ResetStatus.tag === 3) {
            if (model_1.ShowModal) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                JS_runAfter(500, () => {
                    updateModal((_arg_3) => {
                        _arg_3.close();
                    });
                    dispatch(new Msg(1, []));
                });
                break;
            }
            case 1: {
                break;
            }
        }
    });
    const closeModal = (e) => {
        e.preventDefault();
        updateModal((_arg_5) => {
            _arg_5.close();
        });
        dispatch(new Msg(1, []));
    };
    const confirmButton = createElement("button", createObj(Helpers_combineClasses("btn", ofArray([["className", "btn-error"], ["key", "admin-reset-confirm-button"], ["disabled", equals(model_1.ResetStatus, new Remote$1(1, []))], ["onClick", (e_1) => {
        closeModal(e_1);
        dispatch(new Msg(2, [new ApiCall$1(0, [])]));
    }], ["children", TranslationPages_Home__get_ConfirmReset(AppTranslations__get_Home(translations))]]))));
    const dialogProps = new DialogProps((Title = TranslationPages_Home__get_Confirmation(AppTranslations__get_Home(translations)), (Close = TranslationPages_Home__get_Cancel(AppTranslations__get_Home(translations)), new DialogTranslations(Title, TranslationPages_Home__get_ConfirmResetCacheMessage(AppTranslations__get_Home(translations)), Close))), confirmButton);
    return createElement("section", createObj(ofArray([["key", "admin-page"], ["className", "text-sm flex flex-col gap-4"], (elems_4 = [createElement("fieldset", createObj(Helpers_combineClasses("fieldset", ofArray([["key", "admin-disclaimer-fieldset"], ["className", "bg-base-200 border border-base-300 rounded-box p-4"], (elems = [createElement("legend", {
        key: "admin-disclaimer-legend",
        className: "text-sm",
        children: `⚙️ ${TranslationPages_Home__get_Admin(AppTranslations__get_Home(translations))}`,
    }), createElement("p", {
        key: "admin-disclaimer-text",
        children: TranslationPages_Home__get_AdminDisclaimer(AppTranslations__get_Home(translations)),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), createElement("fieldset", createObj(Helpers_combineClasses("fieldset", ofArray([["key", "admin-cache-fieldset"], ["className", "bg-base-200 border border-base-300 rounded-box p-4"], (elems_3 = toList(delay(() => append(singleton(createElement("legend", {
        key: "admin-cache-legend",
        className: "text-sm",
        children: `🗄️ ${TranslationPages_Home__get_ProductCache(AppTranslations__get_Home(translations))}`,
    })), delay(() => append(singleton(createElement("p", {
        key: "admin-cache-description",
        className: "mb-4",
        children: TranslationPages_Home__get_ResetProductCacheDisclaimer(AppTranslations__get_Home(translations)),
    })), delay(() => {
        let elems_1;
        return append(singleton(createElement("button", createObj(Helpers_combineClasses("btn", ofArray([["className", "btn-error"], ["key", "admin-reset-button"], ["onClick", (_arg_6) => {
            dispatch(new Msg(0, []));
            updateModal((_arg_4) => {
                _arg_4.showModal();
            });
            dispatch(new Msg(3, []));
        }], (elems_1 = toList(delay(() => append(singleton(TranslationPages_Home__get_ResetProductCache(AppTranslations__get_Home(translations))), delay(() => {
            if (model_1.ResetStatus.tag === 1) {
                return singleton(createElement("span", createObj(Helpers_combineClasses("loading", ofArray([["className", "loading-spinner"], ["key", "admin-reset-spinner"]])))));
            }
            else {
                return empty();
            }
        })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))), delay(() => {
            let elems_2;
            const matchValue_2 = model_1.ResetStatus;
            switch (matchValue_2.tag) {
                case 3:
                    return singleton(createElement("div", createObj(Helpers_combineClasses("alert", ofArray([["className", "alert-success"], ["key", "reset-cache-success"], ["className", "mt-4 relative"], (elems_2 = [TranslationPages_Home__ResetProductCacheSuccess_7F9DDECF(AppTranslations__get_Home(translations), matchValue_2.fields[0]), createElement("button", createObj(Helpers_combineClasses("btn", ofArray([["className", "btn-sm"], ["className", "btn-circle"], ["className", "btn-ghost"], ["className", "absolute right-2 top-2"], ["children", "✕"], ["onClick", (_arg_7) => {
                        dispatch(new Msg(3, []));
                    }]]))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))));
                case 2:
                    return singleton(apiError_1("reset-cache-error", matchValue_2.fields[0], fullContext.User));
                default: {
                    return empty();
                }
            }
        }));
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), createElement(ModalDialog, {
        key: "admin-reset",
        $key: "admin-reset",
        ref: modalRef,
        props: dialogProps,
        closeModal: closeModal,
    })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

